import { render } from "./Filterimage.vue?vue&type=template&id=e710b29c"
import script from "./Filterimage.vue?vue&type=script&lang=js"
export * from "./Filterimage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\portfolio\\bhavindabhi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__